import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const NOTIFICATION_SETTINGS_DOMAIN = "notification-settings";

export const NOTIFICATION_SETTINGS_DETAIL_ENDPOINT = "detail";
export const NOTIFICATION_SETTINGS_UPDATE_ENDPOINT = "update";
export const NOTIFICATION_SETTINGS_DELETE_ENDPOINT = "delete";

export interface NotificationSettingsDetailType {
  thoughtRecord?: NotificationSettingsType[];
  meditationRecord?: NotificationSettingsType[];
}

export interface NotificationSettingsType {
  time: string;
  dayOfWeekList: number[];
}

export interface NotificationSettingsUpdateType {
  type: "thoughtRecord" | "meditationRecord";
  index?: number;
  notification: NotificationSettingsType;
}

export interface NotificationSettingsDeleteType {
  type: "thoughtRecord" | "meditationRecord";
  index: number;
}

export const notificationSettingsApi = {
  getDetail: () =>
    axiosInstance.get<CustomResponseFormat<NotificationSettingsDetailType>>(
      `${NOTIFICATION_SETTINGS_DOMAIN}/${NOTIFICATION_SETTINGS_DETAIL_ENDPOINT}`
    ),
  update: (data: NotificationSettingsUpdateType) =>
    axiosInstance.post<CustomResponseFormat>(
      `${NOTIFICATION_SETTINGS_DOMAIN}/${NOTIFICATION_SETTINGS_UPDATE_ENDPOINT}`,
      data
    ),
  delete: (data: NotificationSettingsDeleteType) =>
    axiosInstance.post<CustomResponseFormat>(
      `${NOTIFICATION_SETTINGS_DOMAIN}/${NOTIFICATION_SETTINGS_DELETE_ENDPOINT}`,
      data
    ),
};
